import React, { createContext, useContext, useEffect } from "react";

import "./styles/flowstationdashboard.css";
import "./styles/resizable.css";
import "./styles/grid-layout.css";
import { Button, Layout, notification } from "antd";
import { CommandBar } from "@fluentui/react";
import ReportStore from "../../../../shared/ReportStore";
import { SubPageHeaderTitle } from "../../../../shared/SubPageHeaderTitle";
import { Select } from "antd";
import { Filter } from "react-feather";
import { Observer, observer } from "mobx-react-lite";
import FlowstationPerformanceStore from "../store/FlowstationPerformanceStore";
import { FlowstationProductionCard } from "./FlowstationProductionCard";
/* import { FlowstationCapacityCard } from "./FlowstationCapacityCard"; */
import { FlowstationUtilizationCard } from "./FlowstationUtilizationCard";
import { TotalOilCard } from "./TotalOilCard";
import { TotalGasCard } from "./TotalGasCard";
import { TotalBoeCard } from "./TotalBoeCard";
import { Responsive, WidthProvider } from "react-grid-layout";

import { FlowstationProductionPerformance } from "./charts/FlowstationProductionPerformance";
import { FlowstationCapacityUtilization } from "./charts/FlowstationCapacityUtilization";
import { FlowstationCapacityChart } from "./charts/FlowstationCapacityChart";
import MainStore from "../../../home/store/mainStore";

import { ChartContainer } from "../../../../shared/containers/ChartContainer";
import { FlowstationOilProductionDonut } from "./charts/FlowstationOilProductionDonut";
import { FlowstationOilProductionChart } from "./charts/FlowstationOilProductionChart";
import { FlowstationGasProductionDonut } from "./charts/FlowstationGasProductionDonut";
import { FlowstationGasProductionChart } from "./charts/FlowstationGasProductionChart";
import { FlowstationBoeProductionDonut } from "./charts/FlowstationBoeProductionDonut";
import { FlowstationBoeProductionChart } from "./charts/FlowstationBoeProductionChart";
const { Content } = Layout;
const ResponsiveGridLayout = WidthProvider(Responsive);

const flowstationPerformanceStoreCtx = createContext(
  FlowstationPerformanceStore
);

const { Option } = Select;
const reportStoreCtx = createContext(ReportStore);
const mainStoreCtx = createContext(MainStore);
export const FlowStationVisualizationBaseView = observer(() => {
  const flowstationPerformanceStore = useContext(
    flowstationPerformanceStoreCtx
  );
  const mainStore = useContext(mainStoreCtx);

  useEffect(() => {
    async function loadInitialData() {
      try {
        await flowstationPerformanceStore.getInitialData();
      } catch (error) {
        notification.error({
          message: "SPARS Feedback",
          description: `download failed,${error.message}`,
        });
      }
    }
    loadInitialData();
    mainStore.resetAssetContext();
  }, []);
  const reportStore = useContext(reportStoreCtx);

  return (
    <Layout
      style={{
        background: "#fff",
        padding: "10px",
        borderTop: "2px solid #8d6e63",
      }}
    >
      <Content>
        {" "}
        <div className="ms-Grid" dir="ltr">
          <div className="ms-Grid-row">
            <div className="ms-Grid-col ms-sm12">
              <CommandBar
                items={[
                  {
                    key: "1",
                    onRender: () => (
                      <div style={{ paddingTop: "5px" }}>
                        <Observer>
                          {() => (
                            <SubPageHeaderTitle
                              title={`${flowstationPerformanceStore.selMonthName} ${flowstationPerformanceStore.selYear} NAOC Monthly Flowstation Production Performance Dashboard`}
                            />
                          )}
                        </Observer>
                      </div>
                    ),
                  },
                ]}
                farItems={[
                  {
                    key: "2",
                    onRender: () => (
                      <Button
                        type="primary"
                        style={{ marginTop: "5px" }}
                        onClick={() => {
                          reportStore.reportParameters = {
                            month: flowstationPerformanceStore.selMonth,
                          };
                          reportStore.reportName =
                            "QikReach.Reporting.Naoc.FacilityUtilization,QikReach.Reporting";
                          reportStore.showReportDialog = true;
                          reportStore.headerText = `${flowstationPerformanceStore.selMonthName} ${flowstationPerformanceStore.selYear} NAOC Monthly Flowstation Production Performance Dashboard`;
                        }}
                      >
                        Export Dashboard
                      </Button>
                    ),
                  },
                ]}
              ></CommandBar>
            </div>
          </div>
          <div
            className="ms-Grid-row"
            style={{
              marginTop: "5px",
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <div className="ms-Grid-col ms-sm8">
              <CommandBar
                items={[
                  {
                    key: "3",
                    text: "View by",
                    onRenderIcon: () => <Filter style={{ color: "red" }} />,
                  },
                ]}
                farItems={[
                  { text: "Production Year", key: "4" },
                  {
                    key: "5",
                    onRender: () => (
                      <div className="ms-Grid" dir="ltr">
                        <div className="ms-Grid-row">
                          <div
                            className="ms-Grid-col ms-sm6"
                            style={{ paddingTop: "5px" }}
                          >
                            {
                              <Observer>
                                {() => (
                                  <Select
                                    showSearch
                                    style={{ width: 200 }}
                                    placeholder="Select a Year"
                                    value={flowstationPerformanceStore.selYear}
                                    optionFilterProp="children"
                                    filterOption={(input, option) =>
                                      option.children
                                        .toLowerCase()
                                        .indexOf(input.toLowerCase()) >= 0
                                    }
                                    onChange={async (value) => {
                                      try {
                                        console.log(value);
                                        flowstationPerformanceStore.selYear =
                                          value;
                                        await flowstationPerformanceStore.getDashboardData();
                                      } catch (error) {
                                        notification.error({
                                          message: "SPARS Feedback",
                                          description: `download failed,${error.message}`,
                                        });
                                      }
                                    }}
                                  >
                                    {flowstationPerformanceStore.years.map(
                                      (y) => (
                                        <Option value={y} key={y}>
                                          {y}
                                        </Option>
                                      )
                                    )}
                                  </Select>
                                )}
                              </Observer>
                            }
                          </div>
                        </div>
                      </div>
                    ),
                  },
                  { text: "Production Month", key: "6" },
                  {
                    key: "7",
                    onRender: () => (
                      <div className="ms-Grid" dir="ltr">
                        <div className="ms-Grid-row">
                          <div
                            className="ms-Grid-col ms-sm6"
                            style={{ paddingTop: "5px" }}
                          >
                            {" "}
                            {
                              <Observer>
                                {() => (
                                  <Select
                                    showSearch
                                    style={{ width: 200 }}
                                    value={flowstationPerformanceStore.selMonth}
                                    placeholder="Select a month"
                                    optionFilterProp="children"
                                    filterOption={(input, option) =>
                                      option.children
                                        .toLowerCase()
                                        .indexOf(input.toLowerCase()) >= 0
                                    }
                                    onChange={async (value, obj) => {
                                      try {
                                        console.log(value, obj);
                                        flowstationPerformanceStore.selMonth =
                                          value;
                                        flowstationPerformanceStore.selMonthName =
                                          obj.children;
                                        console.log(obj.children);

                                        await flowstationPerformanceStore.getDashboardData();
                                      } catch (error) {
                                        notification.error({
                                          message: "SPARS Feedback",
                                          description: `download failed,${error.message}`,
                                        });
                                      }
                                    }}
                                  >
                                    {flowstationPerformanceStore.monthandYears.map(
                                      (y) => (
                                        <Option value={y.value} key={y.value}>
                                          {y.key}
                                        </Option>
                                      )
                                    )}
                                  </Select>
                                )}
                              </Observer>
                            }
                          </div>
                        </div>
                      </div>
                    ),
                  },
                ]}
              ></CommandBar>
            </div>
          </div>

          <div className="ms-Grid-row">
            <div className="ms-Grid-col ms-sm12">
              <ResponsiveGridLayout
                className="layout"
                draggableCancel=".chart-container-control, .chart-container-controls, .highcharts-container, .highcharts-contextmenu, .highcharts-menu"
                breakpoints={{ lg: 1200, md: 996, sm: 768, xs: 480, xxs: 0 }}
                cols={{ lg: 12, md: 10, sm: 6, xs: 4, xxs: 2 }}
                rowHeight={100}
              >
                <div
                  key="1"
                  data-grid={{ x: 0, y: 0, w: 4, h: 1 }}
                  style={{
                    backgroundColor: "#fff2f2",
                    borderLeft: "5px solid red",
                    boxShadow: "5px 2px 2px 0px rgba(0,0,0,0.1)",
                  }}
                  className=" ms-motion-fadeIn"
                >
                  <TotalOilCard />
                </div>
                <div
                  key="2"
                  data-grid={{ x: 4, y: 0, w: 4, h: 1 }}
                  style={{
                    backgroundColor: "#eaffea",
                    borderLeft: "5px solid green",
                    boxShadow: "5px 2px 2px 0px rgba(0,0,0,0.1)",
                  }}
                  className=" ms-motion-fadeIn"
                >
                  <TotalGasCard />
                </div>
                <div
                  key="3"
                  data-grid={{ x: 8, y: 0, w: 4, h: 1 }}
                  style={{
                    backgroundColor: "#c0c0ff",
                    borderLeft: "5px solid rgb(0,32,96)",
                    boxShadow: "5px 2px 2px 0px rgba(0,0,0,0.1)",
                    height: "100px",
                  }}
                  className=" ms-motion-fadeIn"
                >
                  <TotalBoeCard />
                </div>
                <div
                  key="4"
                  data-grid={{ x: 0, y: 1, w: 8, h: 6 }}
                  style={{
                    backgroundColor: "white",
                  }}
                >
                  <FlowstationProductionCard />
                </div>
                {/*  <div
                  key="5"
                  data-grid={{ x: 4, y: 1, w: 4, h: 4 }}
                  style={{
                    backgroundColor: "white",
                    marginTop: "5px",
                  }}
                >
                  <FlowstationCapacityCard />
                </div> */}
                <div
                  key="6"
                  data-grid={{ x: 8, y: 1, w: 4, h: 6 }}
                  style={{
                    backgroundColor: "white",
                  }}
                >
                  <FlowstationUtilizationCard />
                </div>
                <div
                  key="7"
                  data-grid={{ x: 0, y: 3, w: 4, h: 4 }}
                  style={{
                    backgroundColor: "white",
                  }}
                >
                  <ChartContainer>
                    <FlowstationOilProductionDonut />

                    <FlowstationOilProductionChart />
                  </ChartContainer>
                </div>
                <div
                  key="8"
                  data-grid={{ x: 4, y: 2, w: 4, h: 3 }}
                  style={{
                    backgroundColor: "white",
                  }}
                >
                  <ChartContainer>
                    <FlowstationGasProductionDonut />

                    <FlowstationGasProductionChart />
                  </ChartContainer>
                </div>
                <div
                  key="9"
                  data-grid={{ x: 8, y: 2, w: 4, h: 4 }}
                  style={{
                    backgroundColor: "white",
                  }}
                >
                  <ChartContainer>
                    <FlowstationBoeProductionDonut />

                    <FlowstationBoeProductionChart />
                  </ChartContainer>
                </div>
                <div
                  key="10"
                  data-grid={{ x: 0, y: 3, w: 6, h: 3 }}
                  style={{
                    backgroundColor: "white",
                  }}
                >
                  <FlowstationProductionPerformance />
                </div>
                <div
                  key="11"
                  data-grid={{ x: 6, y: 3, w: 6, h: 3 }}
                  style={{
                    backgroundColor: "white",
                  }}
                >
                  <FlowstationCapacityChart />
                </div>

                <div
                  key="12"
                  data-grid={{ x: 0, y: 4, w: 12, h: 3 }}
                  style={{
                    backgroundColor: "white",
                  }}
                >
                  <FlowstationCapacityUtilization />
                </div>
              </ResponsiveGridLayout>
            </div>
          </div>
        </div>
      </Content>
    </Layout>
  );
});

